module.exports = {"230112001":"金城街道","230112002":"金都街道","230112003":"通城街道","230112004":"河东街道","230112005":"阿什河街道","230112006":"玉泉街道","230112007":"新利街道","230112008":"双丰街道","230112009":"舍利街道","230112010":"小岭街道","230112011":"亚沟街道","230112012":"交界街道","230112103":"蜚克图镇","230112107":"平山镇","230112108":"松峰山镇","230112109":"红星镇","230112112":"金龙山镇","230112113":"杨树镇","230112114":"料甸镇","230112503":"阿城原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230112.json
// module id = 622
// module chunks = 0